/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { LoadingPage } from '@components/Loading/LoadingPage';
import { ReactNode, useCallback } from 'react';

import { useRegisterRenewTokenInterceptor } from '../../hooks/useRegisterRenewTokenInterceptor';
import { getOidc, useOidc } from './OidcContext';

export function OidcWrapper({ children }: { children: ReactNode }) {
    const oidcState = useOidc();

    const renewTokens = useCallback(async () => {
        const oidc = await getOidc();
        if (!oidc.isUserLoggedIn) {
            return Promise.resolve(null);
        }
        try {
            await oidc.renewTokens();
            // After renewal, fetch the updated tokens using getTokens()
            const tokens = oidc.getTokens();
            return tokens.accessToken;
        } catch {
            return null;
        }
    }, []);

    const logout = useCallback(() => {
        return oidcState.logout({ redirectTo: 'home' });
    }, [oidcState]);

    useRegisterRenewTokenInterceptor({
        renewTokenHttpCode: 401,
        isUserLoggedIn: oidcState.isUserLoggedIn,
        renewTokens,
        logout,
    });

    // Only require tokens if the user is actually logged in
    // This allows public routes to render without authentication
    if (oidcState.isUserLoggedIn && !oidcState.tokens?.accessToken) {
        return <LoadingPage />;
    }

    return <>{children}</>;
}
